// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".\\+a5C2 {\n  border-bottom: var(--border-default-gray-extra-light);\n}\n\n.VfD-8 {\n  width: -webkit-max-content;\n  width: -moz-max-content;\n  width: max-content;\n  z-index: 999999;\n}\n\n.Fcnn\\+ {\n  padding: var(--space-100) !important;\n  border-radius: var(--radius-75);\n}\n\n.Fcnn\\+:hover {\n    background-color: var(--surface-brand-hover);\n  }\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"userInfo": "+a5C2",
	"menuPaper": "VfD-8",
	"anchorButton": "Fcnn+"
};
export default ___CSS_LOADER_EXPORT___;
